var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"my-3",attrs:{"fluid":""}},[_c('b-row',_vm._l((_vm.facets),function(facet,idx){return _c('b-col',{key:idx,attrs:{"sm":"12","md":"12","lg":"6","xl":"4"}},[_c('StackedBarsPanel',{attrs:{"label":facet.type,"buckets":facet.buckets,"facet-type":facet.type,"search-index":_vm.searchIndex}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }